"use strict";
var globalThis = require("../internals/global-this");
var fails = require("../internals/fails");
var uncurryThis = require("../internals/function-uncurry-this");
var ArrayBufferViewCore = require("../internals/array-buffer-view-core");
var ArrayIterators = require("../modules/es.array.iterator");
var wellKnownSymbol = require("../internals/well-known-symbol");
var ITERATOR = wellKnownSymbol("iterator");
var Uint8Array = globalThis.Uint8Array;
var arrayValues = uncurryThis(ArrayIterators.values);
var arrayKeys = uncurryThis(ArrayIterators.keys);
var arrayEntries = uncurryThis(ArrayIterators.entries);
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var TypedArrayPrototype = Uint8Array && Uint8Array.prototype;
var GENERIC = !fails(function() {
  TypedArrayPrototype[ITERATOR].call([1]);
});
var ITERATOR_IS_VALUES = !!TypedArrayPrototype && TypedArrayPrototype.values && TypedArrayPrototype[ITERATOR] === TypedArrayPrototype.values && TypedArrayPrototype.values.name === "values";
var typedArrayValues = function values() {
  return arrayValues(aTypedArray(this));
};
exportTypedArrayMethod("entries", function entries() {
  return arrayEntries(aTypedArray(this));
}, GENERIC);
exportTypedArrayMethod("keys", function keys() {
  return arrayKeys(aTypedArray(this));
}, GENERIC);
exportTypedArrayMethod("values", typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, { name: "values" });
exportTypedArrayMethod(ITERATOR, typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, { name: "values" });
